export const simple = [
    'a', 
    'e',
    'i',
    'o',
    'u',
    'y',
]

export const complex = [
    'aa',
    'ae',
    'ai',
    'ao',
    'au',
    'ea',
    'ee',
    'ei',
    'eo',
    'eu',
    'ia',
    'ie',
    'ii',
    'io',
    'iu',
    'oa',
    'oe',
    'oi',
    'oo',
    'ou',
    'ua',
    'ue',
    'ui',
    'uo',
    'uu',
]

